export default "__VITE_ASSET__HH$GwnKq__"